export const ceresos = [
    {
        "municipio" : "Actopan",
        "direccion":"Calle Pensador Mexicano S/N. Col. Centro Norte, (salida a la Estancia) C.P. 42500",
        "telefonolink":"7727272304",
        "telefono":"772 727 23 04"
    },
    {
        "municipio" : "Apan",
        "direccion":"Conocido Presidencia Municipal, Apan, Hgo. C.P. 43900",
        "telefonolink":"7489122196",
        "telefono":"748 912 21 96"
    },
    {"municipio":"	Huasteca	",
        "direccion":"	Carretera Huejutla - San Felipe Orizatlán, Km. 16.3, Predio La Lima, municipio de Jaltocan, Hgo.	",
        "telefonolink":"	77176000	",
        "telefono":"	771 76000 Ext. 4053 y 4553	"
    },
    {"municipio":"	Huichapan	",
    "direccion":"	Av. Hidalgo, S/N, C.P. 42400	",
    "telefonolink":"7617821022",
    "telefono":"761 782 1022	"
    },
            
    {"municipio":"	Ixmiquilpan	",
    "direccion":"	Plaza Principal, S/N, Interior Presidencia Municipal, C.P. 42300	",
    "telefonolink":"7597232783",
    "telefono":"759 723 27 83"
    },
    {"municipio":"	Jacala	",
    "direccion":"	Nicolás Flores y Av. Revolución, C.P. 42200	",
    "telefonolink":"4412933078",
    "telefono":"441 293 30 78	"},
            
    {"municipio":"	Mixquiahuala	",
    "direccion":"	Plaza Principal S/N, Interior Presidencia Municipal, C.P. 42700	",
    "telefonolink":"7387250095",
    "telefono":"738 725 00 95	"},
    {"municipio":"	Molango	",
    "direccion":"	Carretera Atezca S/N, barrio Zacatempa, Molango de Escamilla Hidalgo, C.P. 43100	",
    "telefonolink":"7747450188",
    "telefono":"774 745 01 88"},
    {"municipio":"	Pachuca	",
    "direccion":"	Blvd. del Minero S/N, Carr. Pachuca – Actopan, Km. 6.5, C.P. 42030	",
    "telefonolink":"7717136539",
    "telefono":"771 713 65 39 y 771 713 00 59"},
            
    {"municipio":"	Tenango de Doria	",
    "direccion":"	Carr. Pachuca – Tenango S/N, C.P. 43480	",
    "telefonolink":"7767553610",
    "telefono":"776 755 36 10	"},
    {"municipio":"	Tula de Allende	",
    "direccion":"	Carretera Tula – Michimaloya K.M 1.5, colonia La Malinche, C.P. 42800	",
    "telefonolink":"7737325342",
    "telefono":"773 732 53 42	"},
    {"municipio":"	Tulancingo	",
    "direccion":"	Av. de los Laureles S/N, Fracc. La Morena, C.P. 43625	",
    "telefonolink":"7757538088",
    "telefono":"775 753 80 88 y 775 753 19 66"},
            
    {"municipio":"	Centro de Internamiento para Adolescentes	",
    "direccion":"	Blvd. del Minero esquina con calle Tamaulipas, Col. Venustiano Carranza, Pachuca de Soto, Hgo.	",
    "telefonolink":"7717131416",
    "telefono":"771 713 1416"}
       
]